import * as React from 'react'
import { NumericFormat } from 'react-number-format'

interface EditableTableCellProps {
  value: number | string
  onChange?: (value: number) => void
  onBlur?: (value: number) => void
  readOnly?: boolean
  decimalScale?: number
  className?: string
  style?: React.CSSProperties
}

const EditableTableCell: React.FC<EditableTableCellProps> = ({
  value,
  onChange,
  onBlur,
  readOnly = false,
  decimalScale = 2,
  className = '',
  style,
}) => {
  const numericValue =
    typeof value === 'string'
      ? parseFloat(value.replace(/\s/g, '').replace(',', '.')) || 0
      : value

  const isLeftAligned = className.includes('tw-text-left')
  const textAlignClass = isLeftAligned ? 'tw-text-left' : 'tw-text-right'
  const widthClass = className.includes('tw-w-') ? '' : 'tw-w-full'

  return (
    <NumericFormat
      className={`${widthClass} ${textAlignClass} tw-outline-none focus:tw-outline-none ${className}`}
      disabled={readOnly}
      decimalScale={decimalScale}
      fixedDecimalScale={true}
      value={numericValue}
      readOnly={readOnly}
      thousandSeparator=" "
      decimalSeparator=","
      allowedDecimalSeparators={['.', ',']}
      style={{
        fontWeight: 400,
        fontSize: 12,
        color: '#1f2937',
        background: 'transparent',
        border: 'none',
        ...style,
      }}
      onClick={(element) => {
        element.stopPropagation()
      }}
      onFocus={(element) => {
        element.target.select()
        element.stopPropagation()
      }}
      onChange={(element) => {
        const val = element.target.value
        const numValue =
          parseFloat(val.replace(/\s/g, '').replace(',', '.')) || 0
        onChange?.(numValue)
      }}
      onBlur={(element) => {
        const val = element.target.value
        const numValue =
          parseFloat(val.replace(/\s/g, '').replace(',', '.')) || 0
        onBlur?.(numValue)
      }}
    />
  )
}

export default EditableTableCell
